import { get } from 'lodash';
import { reject, resolve } from 'redux-optimist-promise';
import {
  FETCH_ADDITIONAL_ACCOMMODATIONS,
  GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT,
} from 'Store/booking/additional-accommodations/additionalAccommodations.action';

function isLoadingFilteredAccommodationsAlternativesByComfort(
  state: boolean = false,
  action: Action<any> | null | undefined,
): boolean {
  switch (get(action, 'type')) {
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
      return true;

    case reject(GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT):
    case resolve(GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT):
      return false;

    default:
      return state;
  }
}

export default isLoadingFilteredAccommodationsAlternativesByComfort;
